// extracted by mini-css-extract-plugin
module.exports = {"container":"Geopolitics_title_container__3GSgl","title":"Geopolitics_title_title__2knn8","subTitle":"Geopolitics_title_subTitle__1dGYU"};